if (!window.__shopTheLookInitialized) {
  window.__shopTheLookInitialized = true;

  document.addEventListener("DOMContentLoaded", function () {
    initializeShopTheLook();
  });

  document.addEventListener('shopify:section:load', function () {
    initializeShopTheLook();
  });

  document.addEventListener('shopify:block:select', function (event) {    
    const blockId = event.detail.blockId;
    const selectedPin = document.querySelector(`.js-pin[data-block-id='${blockId}']`);

    if (selectedPin) {
      selectedPin.click();
    }
  });
}

function initializeShopTheLook() {
  document.querySelectorAll(".js-shop-the-look-carousel").forEach((element, index) => {
    const uniqueClass = `js-shop-the-look-carousel-${String(index + 1).padStart(2, "0")}`;
    element.classList.add(uniqueClass);

    const splide = new Splide(element, {
      type: "fade",
      rewind: true,
    });

    splide.on('moved', function (newIndex) {
      updateBackgroundColor(element.closest(".js-shop-the-look"), newIndex);
    });

    splide.mount();
    element.splideInstance = splide;
  });

  document.querySelectorAll(".js-pin").forEach(pin => {
    pin.addEventListener("click", function (e) {
      e.preventDefault();

      const shopTheLook = this.closest(".js-shop-the-look");
      if (!shopTheLook) return;

      const carousel = shopTheLook.querySelector(".js-shop-the-look-carousel");
      if (!carousel || !carousel.splideInstance) return;

      const index = parseInt(this.getAttribute("data-index"), 10) - 1;
      if (!isNaN(index)) {
        carousel.splideInstance.go(index);
      }

      shopTheLook.querySelectorAll(".js-pin").forEach(pin => pin.classList.remove("active"));
      this.classList.add("active");

      updateBackgroundColor(shopTheLook, index);

      carousel.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  });
}

function updateBackgroundColor(shopTheLook, index) {
  if (!shopTheLook) return;
  
  const pins = shopTheLook.querySelectorAll(".js-pin");
  if (pins.length > index) {
    const activePin = pins[index];
    const bgColor = activePin.getAttribute("data-background-color");
    if (bgColor) {
      shopTheLook.style.backgroundColor = bgColor;
    }
  }
}
